import { render, staticRenderFns } from "./PendingReturnsList.vue?vue&type=template&id=31143108&"
import script from "./PendingReturnsList.vue?vue&type=script&lang=js&"
export * from "./PendingReturnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports